import { render, staticRenderFns } from "./BeneficiaryCard.vue?vue&type=template&id=5ce8d46d&scoped=true&"
import script from "./BeneficiaryCard.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryCard.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryCard.vue?vue&type=style&index=0&id=5ce8d46d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce8d46d",
  null
  
)

export default component.exports